import script from "./FormParceriaExterna.vue?vue&type=script&setup=true&lang=js"
export * from "./FormParceriaExterna.vue?vue&type=script&setup=true&lang=js"

import "./FormParceriaExterna.vue?vue&type=style&index=0&id=3c7518b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c7518b6"]])

export default __exports__